/**
 * Object/plugin registry (impl-expectation #7/#8). Live-object node types register through a
 * stable, engine-agnostic API so new object kinds are added without touching the engine or
 * leaking PM types to hosts. First cut ships the OQ-6 set (reminder / task / decision / truth).
 */

/** A registered live-object definition, described in plain data. */
export interface LiveObjectDefinition {
  /** Node type name in the schema, e.g. `task_card`. */
  nodeType: string;
  /** Stable kind tag persisted on the node, e.g. `task`. */
  kind: string;
  /** Human label for menus/chrome. */
  label: string;
  /** Produce the searchable summary text stored on the node (keeps REST/search valid). */
  summarize(data: Record<string, unknown>): string;
}

const registry = new Map<string, LiveObjectDefinition>();

export function registerLiveObject(def: LiveObjectDefinition): void {
  registry.set(def.kind, def);
}

export function getLiveObject(kind: string): LiveObjectDefinition | undefined {
  return registry.get(kind);
}

export function listLiveObjects(): LiveObjectDefinition[] {
  return [...registry.values()];
}

// OQ-6 first cut — matches the doc 03 narrative. The rest are deferred and register later.
registerLiveObject({ nodeType: 'reminder_chip', kind: 'reminder', label: 'Reminder', summarize: (d) => String(d.text ?? 'Reminder') });
registerLiveObject({ nodeType: 'task_card', kind: 'task', label: 'Task', summarize: (d) => String(d.title ?? 'Task') });
registerLiveObject({ nodeType: 'decision_card', kind: 'decision', label: 'Decision', summarize: (d) => String(d.statement ?? 'Decision') });
registerLiveObject({ nodeType: 'truth_card', kind: 'truth', label: 'Truth', summarize: (d) => String(d.statement ?? 'Truth') });
